import { createSelector } from 'reselect';
const getRouteHooks = (routeHooksDSL) => {
    return routeHooksDSL;
};
export const getAfterEachHook = createSelector(getRouteHooks, routeHooksDSL => routeHooksDSL === null || routeHooksDSL === void 0 ? void 0 : routeHooksDSL.afterEach);
export const getBeforeEachHook = createSelector(getRouteHooks, routeHooksDSL => routeHooksDSL === null || routeHooksDSL === void 0 ? void 0 : routeHooksDSL.beforeEach);
export const getBeforeEachCode = createSelector(getBeforeEachHook, beforeEachHook => beforeEachHook === null || beforeEachHook === void 0 ? void 0 : beforeEachHook.code);
export const getAfterEachCode = createSelector(getAfterEachHook, afterEachHook => afterEachHook === null || afterEachHook === void 0 ? void 0 : afterEachHook.code);
